<template>
  <div>
    <div v-if="!showAddUser && hasPermission('Add User')" class="btn-group-hdr">
      <div class="btn-group btn-group-toggle">
        <!--<router-link :to="create" class="btn btn-primary btn-sm">Add User</router-link>-->
        <button class="btn btn-primary btn-sm" @click="addForm()">Add User</button>
      </div>
    </div>

    <div class="title-hdr bg-dark">
      {{title}}
    </div>

    <!-- AddEditUser component -->
    <add-edit-user
      v-if="showAddUser"
      :user="editingUser"
      @cancel="cancelEdit"
      @user-added="onUserAdded"
      @user-updated="onUserUpdated"
    ></add-edit-user>

    <div class="card" v-if="!showAddUser">
      <div class="card-body">
        <data-viewer :source="source" :thead="thead" ref="dataViewer">
          <template slot-scope="props">
            <tr>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.username }}</td>
              <td>{{ props.item.role_name || 'No Role' }}</td>
              <td>
                <button v-if="hasPermission('Edit User')" class="btn btn-primary btn-sm" data-bs-toggle="tooltip" title="Edit User" @click="openEditUserForm(props.item)">
                  <i class="fas fa-pen fa-sm"></i>
                </button>
                <!--<button class="btn btn-danger btn-sm ms-1" data-bs-toggle="tooltip" title="Delete User" @click="deleteUser(props.item)">
                  <i class="fas fa-trash fa-sm"></i>
                </button>-->
              </td>
            </tr>
          </template>
        </data-viewer>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import { baseUrl } from './../../../.env.js'
  import { bus } from '../../../main.js'
  import AddEditUser from './AddEditUser.vue'
  import DataViewer from './../common/DataViewer.vue'

  export default {
    name: 'UserData',
    props: {
      hasPermission: {
        type: Function,
        required: true
      }
    },
    components: {
      DataViewer,
      AddEditUser
    },
    data() {
      return {
        certs: {},
        baseUrl : baseUrl,
        title: 'Users',
        source: '/user/sys/users_with_role',
        showAddUser: false,
        editingUser: null
      }
    },
    mounted() {
      this.$store.commit('selectedTab', 'users');
      // Removed fetchRoles call since roles are no longer fetched
    },
    methods: {
      addForm() {
        this.editingUser = null
        this.showAddUser = true
      },
      openEditUserForm(user) {
        this.editingUser = user
        this.showAddUser = true
      },
      cancelEdit() {
        this.showAddUser = false
        this.editingUser = null
      },
      onUserAdded() {
        this.showAddUser = false
        this.editingUser = null
        this.refreshData()
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: 'User added successfully!'
        })
      },
      onUserUpdated() {
        this.showAddUser = false
        this.editingUser = null
        this.refreshData()
        Swal.fire({
          icon: 'success',
          title: 'Success',
          text: 'User updated successfully!'
        })
      },
      refreshData() {
        // Refresh the data-viewer by reloading the source data
        this.$refs.dataViewer && this.$refs.dataViewer.reload && this.$refs.dataViewer.reload()
      },
      async deleteUser(user) {
        const result = await Swal.fire({
          title: 'Are you sure?',
          text: `Do you want to delete user "${user.name}"? This action cannot be undone.`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#d33',
          cancelButtonColor: '#3085d6',
          confirmButtonText: 'Yes, delete it!'
        })

        if (result.isConfirmed) {
          try {
            await axios.delete(`${this.baseUrl}/user/sys/users/${user.id}`)
            Swal.fire({
              icon: 'success',
              title: 'Deleted!',
              text: 'User has been deleted.'
            })
            this.refreshData()
          } catch (error) {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: (error.response && error.response.data && error.response.data.message) || 'Failed to delete user.'
            })
          }
        }
      }
    },
    computed: {
      thead() {
        return [
          {title: 'Name', key: 'name', sort: true},
          {title: 'Username', key: 'username', sort: true},
          {title: 'Role', key: 'role_name', sort: false}
        ]
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/users/users/UserData.vue